"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProtocolType = /** @class */ (function () {
    function ProtocolType() {
    }
    ProtocolType.IC3V1SDK = 0;
    ProtocolType.IC3V2SDK = 1;
    ProtocolType.MockIC3SDK = 2;
    return ProtocolType;
}());
exports.default = ProtocolType;
//# sourceMappingURL=ProtocoleType.js.map